import {UtilityApiDto} from "../../api/model/rest";

export default class Utility {
	constructor(public readonly id: string,
		public readonly name: string) {}

	static fromJson(json: UtilityApiDto): Utility {
		return new Utility(json.id, json.name);
	}

	toJson(): UtilityApiDto {
		return {
			id: this.id,
			name: this.name
		};
	}

	copy({name = this.name}) {
		return new Utility(this.id, name);
	}
}